import _ from 'lodash/fp';
import { Observable } from 'rxjs/Rx';
import { database } from '../firebase-app';

export const fetchCollection = ref =>
  () => database.ref(ref).once('value').then(snapshot => snapshot.val());

export const listen = ref =>
  database.ref(ref).observe('value').map(snapshot => snapshot.toJSON());

export const pushOne = ref =>
  item => database.ref(ref).push(item).then(({ key }) => ({ [key]: item }));

export const deleteOne = ref =>
  id => database.ref(`${ref}/${id}`).remove().then(() => id);

export const updateOne = ref =>
  ({ id, fields }) =>
    database.ref(`${ref}/${id}`).update(fields).then(() => ({ [id]: fields }));

export const setOne = ref =>
  collection => database.ref(ref).set(collection).then(() => collection);



// WEBPACK FOOTER //
// ./src/api/firebase.js